<nz-layout class="layout" [attr.data-build]="buildVersion">
	<nz-sider [nzCollapsed]="true" [class.d-none]="!authData">
		<div class="logo"><img src="/assets/images/logo.png" alt="Logo"></div>
		<ul nz-menu nzTheme="dark" nzMode="inline">
			@for (menu of menuItems; track $index) {
				<li nz-submenu [nzTitle]="menu.title" >
					<ul>
						@for (item of menu.items; track $index) {
							@if (item?.hidden !== true) {
								<li nz-menu-item 
									[nzSelected]="isMenuSelected(item.title)"
									(click)="navigateToPage(item.path)"
								>
									<span nz-icon [nzType]="item.icon" nzTheme="outline" ></span>
									<span class="menu-title">{{ item.title }}</span>
								</li>
							}
						}
					</ul>
				</li>
			}
		</ul>
	</nz-sider>
	<nz-layout>
		<nz-content>
			<div class="inner-content" [class.test-env]="testMode">
				<ng-container *ngIf="testMode">
					<div class="test-env-block">This is TEST Environment.</div>
				</ng-container>
				<router-outlet></router-outlet>
				<div class="empty-space-block" [class.d-none]="!authData">&nbsp;</div>
			</div>
		</nz-content>
		<nz-footer>Snapfix v{{ appVersion }} ©{{ year }}</nz-footer>
	</nz-layout>
</nz-layout>